import AOS from 'aos';

import './src/styles/satoshi.css';
import './src/styles/global.css';
import 'aos/dist/aos.css';

import 'notie/dist/notie.min.css';

AOS.init();
